export default __webpack_public_path__ + "static/int-1-lg-906b23fd64a2a3afab2f4b92d1e6d468.png";